import { fork, call, Effect } from "redux-saga/effects";

export const shouldPersistOffline = async (): Promise<boolean> => {
  return false;
};

export const callWithPersistence = function* <T>(
  firestoreCall: () => Generator<Effect, T, any>
): any {
  yield firestoreCall();
};
